import { InjectionToken } from '@angular/core';

export const SOFTLINE_MODULE_CLAIM_REPORT = 'gewerbe-claim-report';
export const SOFTLINE_PERMISSION_CLAIM_REPORT = 'SOFTAPPS.CLAIM_REPORT';

export interface ClaimReportModuleConfig {
  /** Placeholder — replace with real module-level config flags. */
  enabled?: boolean;
}

export const DEFAULT_CLAIM_REPORT_CONFIG: Required<ClaimReportModuleConfig> = {
  enabled: true,
};

export const SOFTLINE_CONFIG_CLAIM_REPORT =
  new InjectionToken<ClaimReportModuleConfig>(
    'SOFTLINE_CONFIG_CLAIM_REPORT',
    { factory: () => DEFAULT_CLAIM_REPORT_CONFIG }
  );
